var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{ref:"timeSelect",on:{"change":_vm.handleChange},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},[_c('associateColumn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }